import React from 'react';

export type PropsWrapper<T> = {
  index: number;
  props: T;
  setProps: (propsTransformFunction: (propsCurrent: T) => T) => void;
  setPropsAll: (propsTransformFunction: (propsCurrentAll: T[]) => T[]) => void;
};

export type ListPropsHelperArgs<T> = {
  listProps: T[];
  setListProps: (listProps: T[]) => void;
  children: (propsWrapper: PropsWrapper<T>) => React.ReactFragment;
};

export function ListPropsHelper<T>(props: ListPropsHelperArgs<T>) {
  return (
    <>
      {props.listProps.map((listItem, index) =>
        props.children({
          index: index,
          props: props.listProps[index],
          setProps: (updateFunction: (layoutProps: T) => T) => {
            const listItemsNew = [...props.listProps];
            listItemsNew[index] = updateFunction(listItemsNew[index]);
            props.setListProps(listItemsNew);
          },
          setPropsAll: (updateFunction: (propsAll: T[]) => T[]) => {
            const listItemsNew = updateFunction(updateFunction([...props.listProps]));
            props.setListProps(listItemsNew);
          },
        }),
      )}
    </>
  );
}
